import React from 'react';

import PageTemplate, { pageCommonPropTypes, renderCmsComponents } from './templates/PageTemplate';

const ContributorPage = ({ content = {}, fpti = {}, pageInfo = {} }) => {
  const {
    components = [],
    subNav,
    aboveHeader,
    articleStickyButton,
  } = content.pageData || {};

  return (
    <PageTemplate
      fpti={fpti}
      subNav={subNav}
      aboveHeader={aboveHeader}
      pageInfo={pageInfo}
      articleStickyButton={articleStickyButton}
    >
      {renderCmsComponents(components, pageInfo)}
    </PageTemplate>
  );
};

ContributorPage.propTypes = pageCommonPropTypes;

export default ContributorPage;
